module.exports = __webpack_public_path__ + "static/media/img_feature_photo1.71be063e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_feature_photo1.png
// module id = 788
// module chunks = 0